import { render, staticRenderFns } from "./FormOrdersToInvoice.vue?vue&type=template&id=3d63c118&"
import script from "./FormOrdersToInvoice.vue?vue&type=script&lang=js&"
export * from "./FormOrdersToInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports